export const officeRouteName = {
  index: "offices.index",
};

export const officeRoute = [
  {
    path: "/offices",
    name: officeRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "office",
      breadcrumbs: () => {
        return [{ title: "Office" }];
      },
    },
  },
];
